import { api } from "../services/api-client";
import type { ApiResponse } from "../types/api.types";

export interface AdminUser {
  id: string;
  email: string | null;
  username: string | null;
  role: "user" | "admin";
}

// POST /v2/auth/login answers with a flat body, not the { success, data } envelope.
interface LoginResponse {
  token: string;
  refreshToken: string;
}

export const loginRequest = (username: string, password: string) =>
  api.post<LoginResponse>("/auth/login", { username, password }, { auth: false });

export const fetchAdminMe = async (): Promise<AdminUser> =>
  (await api.get<ApiResponse<AdminUser>>("/admin/me")).data;

// Ends the session the refresh token belongs to (this browser tab's), nothing else.
// The refresh token is the credential, so no bearer header is sent: logout must still
// work after the 15-minute access token has expired.
export const logoutRequest = (refreshToken: string) =>
  api.post("/auth/logout", { refreshToken }, { auth: false });
